(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["section-press"] && !window.DesignMode) return;
  try {
    
$('.engoj-press-tab').on('click', function (e) {
e.preventDefault();
$('.engoj-press-panel').removeClass('d-block');
$('.engoj-press-tab').removeClass('active');
$(this).addClass('active');
$($(this).attr('href')).addClass('d-block');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testimonial"] && !window.DesignMode) return;
  try {
    
  $('.engoj-section-testimonial').owlCarousel({
      itemsCustom : [
        [0, 1],
        [1200, 2]
	  ],
      navigation : true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopilaunch-rewards-page-template"] && !window.DesignMode) return;
  try {
    
if (window.matchMedia("(max-width: 950px)").matches) {
  $('.js-benefits-container').owlCarousel({
      itemsCustom : [
        [0, 1],
        [1200, 2]
	  ],
      navigation : true
  });
}

$('.js-btn-question').on('click', function (e) {
e.preventDefault();
$(this).find('.icon-1').toggleClass('d-none');
$(this).find('.icon-2').toggleClass('d-none');
$(this).closest('.faq_b').find('.js-content-anwer').toggleClass('d-none');
});

  } catch(e) { console.error(e); }
})();

})();
